/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthGetTwoFactorVerificationProvidersParams,
  AuthMagicLoginParams,
  ChangePasswordDTO,
  ConfirmEmailDTO,
  ConfirmEmailResultDTO,
  ConfirmPhoneNumberDTO,
  EmailVerificationStatusDTO,
  ForgotPasswordDTO,
  ImpersonationStatusDTO,
  LoginDTO,
  LoginResponseDTO,
  MagicLinkRequestDTO,
  MagicLinkResponseDto,
  ProductEmailPreferenceDTO,
  RegisterDTO,
  RegisterResponseDTO,
  ResetPasswordDTO,
  ReturnToOriginalSessionDTO,
  SendTwoFactorCodeDTO,
  TokenResponseDTO,
  UpdateAccountDTO,
  UpdateAccountResponseDTO,
  UpdateProductEmailPreferenceDTO,
  UserDTO,
  VerifyTwoFactorCodeDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const authLogin = (
    loginDTO: LoginDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LoginResponseDTO>(
      {url: `/api/Auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginDTO, signal
    },
      );
    }
  


export const getAuthLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: LoginDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: LoginDTO}, TContext> => {
    
const mutationKey = ['authLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogin>>, {data: LoginDTO}> = (props) => {
          const {data} = props ?? {};

          return  authLogin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
    export type AuthLoginMutationBody = LoginDTO
    export type AuthLoginMutationError = ErrorType<unknown>

    export const useAuthLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: LoginDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogin>>,
        TError,
        {data: LoginDTO},
        TContext
      > => {

      const mutationOptions = getAuthLoginMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authRegister = (
    registerDTO: RegisterDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegisterResponseDTO>(
      {url: `/api/Auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerDTO, signal
    },
      );
    }
  


export const getAuthRegisterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRegister>>, TError,{data: RegisterDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authRegister>>, TError,{data: RegisterDTO}, TContext> => {
    
const mutationKey = ['authRegister'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRegister>>, {data: RegisterDTO}> = (props) => {
          const {data} = props ?? {};

          return  authRegister(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof authRegister>>>
    export type AuthRegisterMutationBody = RegisterDTO
    export type AuthRegisterMutationError = ErrorType<unknown>

    export const useAuthRegister = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRegister>>, TError,{data: RegisterDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRegister>>,
        TError,
        {data: RegisterDTO},
        TContext
      > => {

      const mutationOptions = getAuthRegisterMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Resend email confirmation for the current authenticated user (profile page action).
 */
export const authResendEmailConfirmation = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmailVerificationStatusDTO>(
      {url: `/api/Auth/resend-email-confirmation`, method: 'POST', signal
    },
      );
    }
  


export const getAuthResendEmailConfirmationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResendEmailConfirmation>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authResendEmailConfirmation>>, TError,void, TContext> => {
    
const mutationKey = ['authResendEmailConfirmation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authResendEmailConfirmation>>, void> = () => {
          

          return  authResendEmailConfirmation()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthResendEmailConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof authResendEmailConfirmation>>>
    
    export type AuthResendEmailConfirmationMutationError = ErrorType<unknown>

    /**
 * @summary Resend email confirmation for the current authenticated user (profile page action).
 */
export const useAuthResendEmailConfirmation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResendEmailConfirmation>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authResendEmailConfirmation>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthResendEmailConfirmationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authResendPhoneNumberConfirmation = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Auth/resend-phone-number-confirmation`, method: 'POST', signal
    },
      );
    }
  


export const getAuthResendPhoneNumberConfirmationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResendPhoneNumberConfirmation>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authResendPhoneNumberConfirmation>>, TError,void, TContext> => {
    
const mutationKey = ['authResendPhoneNumberConfirmation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authResendPhoneNumberConfirmation>>, void> = () => {
          

          return  authResendPhoneNumberConfirmation()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthResendPhoneNumberConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof authResendPhoneNumberConfirmation>>>
    
    export type AuthResendPhoneNumberConfirmationMutationError = ErrorType<unknown>

    export const useAuthResendPhoneNumberConfirmation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResendPhoneNumberConfirmation>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authResendPhoneNumberConfirmation>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthResendPhoneNumberConfirmationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authConfirmEmail = (
    confirmEmailDTO: ConfirmEmailDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConfirmEmailResultDTO>(
      {url: `/api/Auth/confirm-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmEmailDTO, signal
    },
      );
    }
  


export const getAuthConfirmEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmail>>, TError,{data: ConfirmEmailDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmail>>, TError,{data: ConfirmEmailDTO}, TContext> => {
    
const mutationKey = ['authConfirmEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authConfirmEmail>>, {data: ConfirmEmailDTO}> = (props) => {
          const {data} = props ?? {};

          return  authConfirmEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthConfirmEmailMutationResult = NonNullable<Awaited<ReturnType<typeof authConfirmEmail>>>
    export type AuthConfirmEmailMutationBody = ConfirmEmailDTO
    export type AuthConfirmEmailMutationError = ErrorType<unknown>

    export const useAuthConfirmEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmail>>, TError,{data: ConfirmEmailDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authConfirmEmail>>,
        TError,
        {data: ConfirmEmailDTO},
        TContext
      > => {

      const mutationOptions = getAuthConfirmEmailMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authConfirmPhoneNumber = (
    confirmPhoneNumberDTO: ConfirmPhoneNumberDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TokenResponseDTO>(
      {url: `/api/Auth/confirm-phone-number`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmPhoneNumberDTO, signal
    },
      );
    }
  


export const getAuthConfirmPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmPhoneNumber>>, TError,{data: ConfirmPhoneNumberDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authConfirmPhoneNumber>>, TError,{data: ConfirmPhoneNumberDTO}, TContext> => {
    
const mutationKey = ['authConfirmPhoneNumber'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authConfirmPhoneNumber>>, {data: ConfirmPhoneNumberDTO}> = (props) => {
          const {data} = props ?? {};

          return  authConfirmPhoneNumber(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthConfirmPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof authConfirmPhoneNumber>>>
    export type AuthConfirmPhoneNumberMutationBody = ConfirmPhoneNumberDTO
    export type AuthConfirmPhoneNumberMutationError = ErrorType<unknown>

    export const useAuthConfirmPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmPhoneNumber>>, TError,{data: ConfirmPhoneNumberDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authConfirmPhoneNumber>>,
        TError,
        {data: ConfirmPhoneNumberDTO},
        TContext
      > => {

      const mutationOptions = getAuthConfirmPhoneNumberMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authForgotPassword = (
    forgotPasswordDTO: ForgotPasswordDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/Auth/forgot-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordDTO, signal
    },
      );
    }
  


export const getAuthForgotPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError,{data: ForgotPasswordDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError,{data: ForgotPasswordDTO}, TContext> => {
    
const mutationKey = ['authForgotPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authForgotPassword>>, {data: ForgotPasswordDTO}> = (props) => {
          const {data} = props ?? {};

          return  authForgotPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authForgotPassword>>>
    export type AuthForgotPasswordMutationBody = ForgotPasswordDTO
    export type AuthForgotPasswordMutationError = ErrorType<unknown>

    export const useAuthForgotPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError,{data: ForgotPasswordDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authForgotPassword>>,
        TError,
        {data: ForgotPasswordDTO},
        TContext
      > => {

      const mutationOptions = getAuthForgotPasswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authChangePassword = (
    changePasswordDTO: ChangePasswordDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Auth/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordDTO, signal
    },
      );
    }
  


export const getAuthChangePasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authChangePassword>>, TError,{data: ChangePasswordDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authChangePassword>>, TError,{data: ChangePasswordDTO}, TContext> => {
    
const mutationKey = ['authChangePassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authChangePassword>>, {data: ChangePasswordDTO}> = (props) => {
          const {data} = props ?? {};

          return  authChangePassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authChangePassword>>>
    export type AuthChangePasswordMutationBody = ChangePasswordDTO
    export type AuthChangePasswordMutationError = ErrorType<unknown>

    export const useAuthChangePassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authChangePassword>>, TError,{data: ChangePasswordDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authChangePassword>>,
        TError,
        {data: ChangePasswordDTO},
        TContext
      > => {

      const mutationOptions = getAuthChangePasswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authResetPasword = (
    resetPasswordDTO: ResetPasswordDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TokenResponseDTO>(
      {url: `/api/Auth/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordDTO, signal
    },
      );
    }
  


export const getAuthResetPaswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResetPasword>>, TError,{data: ResetPasswordDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authResetPasword>>, TError,{data: ResetPasswordDTO}, TContext> => {
    
const mutationKey = ['authResetPasword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authResetPasword>>, {data: ResetPasswordDTO}> = (props) => {
          const {data} = props ?? {};

          return  authResetPasword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthResetPaswordMutationResult = NonNullable<Awaited<ReturnType<typeof authResetPasword>>>
    export type AuthResetPaswordMutationBody = ResetPasswordDTO
    export type AuthResetPaswordMutationError = ErrorType<unknown>

    export const useAuthResetPasword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResetPasword>>, TError,{data: ResetPasswordDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authResetPasword>>,
        TError,
        {data: ResetPasswordDTO},
        TContext
      > => {

      const mutationOptions = getAuthResetPaswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authGetTwoFactorVerificationProviders = (
    params?: AuthGetTwoFactorVerificationProvidersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Auth/two-factor-verification-providers`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAuthGetTwoFactorVerificationProvidersQueryKey = (params?: AuthGetTwoFactorVerificationProvidersParams,) => {
    return [`/api/Auth/two-factor-verification-providers`, ...(params ? [params]: [])] as const;
    }

    
export const getAuthGetTwoFactorVerificationProvidersQueryOptions = <TData = Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError = ErrorType<unknown>>(params?: AuthGetTwoFactorVerificationProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthGetTwoFactorVerificationProvidersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>> = ({ signal }) => authGetTwoFactorVerificationProviders(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthGetTwoFactorVerificationProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>>
export type AuthGetTwoFactorVerificationProvidersQueryError = ErrorType<unknown>


export function useAuthGetTwoFactorVerificationProviders<TData = Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError = ErrorType<unknown>>(
 params: undefined |  AuthGetTwoFactorVerificationProvidersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>,
          TError,
          Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetTwoFactorVerificationProviders<TData = Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError = ErrorType<unknown>>(
 params?: AuthGetTwoFactorVerificationProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>,
          TError,
          Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetTwoFactorVerificationProviders<TData = Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError = ErrorType<unknown>>(
 params?: AuthGetTwoFactorVerificationProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthGetTwoFactorVerificationProviders<TData = Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError = ErrorType<unknown>>(
 params?: AuthGetTwoFactorVerificationProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetTwoFactorVerificationProviders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthGetTwoFactorVerificationProvidersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const authSendTwoFactorVerificationCode = (
    sendTwoFactorCodeDTO: SendTwoFactorCodeDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Auth/send-two-factor-verification-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendTwoFactorCodeDTO, signal
    },
      );
    }
  


export const getAuthSendTwoFactorVerificationCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSendTwoFactorVerificationCode>>, TError,{data: SendTwoFactorCodeDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authSendTwoFactorVerificationCode>>, TError,{data: SendTwoFactorCodeDTO}, TContext> => {
    
const mutationKey = ['authSendTwoFactorVerificationCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authSendTwoFactorVerificationCode>>, {data: SendTwoFactorCodeDTO}> = (props) => {
          const {data} = props ?? {};

          return  authSendTwoFactorVerificationCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthSendTwoFactorVerificationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authSendTwoFactorVerificationCode>>>
    export type AuthSendTwoFactorVerificationCodeMutationBody = SendTwoFactorCodeDTO
    export type AuthSendTwoFactorVerificationCodeMutationError = ErrorType<unknown>

    export const useAuthSendTwoFactorVerificationCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSendTwoFactorVerificationCode>>, TError,{data: SendTwoFactorCodeDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authSendTwoFactorVerificationCode>>,
        TError,
        {data: SendTwoFactorCodeDTO},
        TContext
      > => {

      const mutationOptions = getAuthSendTwoFactorVerificationCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authVerifyTwoFactorCode = (
    verifyTwoFactorCodeDTO: VerifyTwoFactorCodeDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TokenResponseDTO>(
      {url: `/api/Auth/verify-two-factor-verification-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyTwoFactorCodeDTO, signal
    },
      );
    }
  


export const getAuthVerifyTwoFactorCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyTwoFactorCode>>, TError,{data: VerifyTwoFactorCodeDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authVerifyTwoFactorCode>>, TError,{data: VerifyTwoFactorCodeDTO}, TContext> => {
    
const mutationKey = ['authVerifyTwoFactorCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authVerifyTwoFactorCode>>, {data: VerifyTwoFactorCodeDTO}> = (props) => {
          const {data} = props ?? {};

          return  authVerifyTwoFactorCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthVerifyTwoFactorCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authVerifyTwoFactorCode>>>
    export type AuthVerifyTwoFactorCodeMutationBody = VerifyTwoFactorCodeDTO
    export type AuthVerifyTwoFactorCodeMutationError = ErrorType<unknown>

    export const useAuthVerifyTwoFactorCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyTwoFactorCode>>, TError,{data: VerifyTwoFactorCodeDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authVerifyTwoFactorCode>>,
        TError,
        {data: VerifyTwoFactorCodeDTO},
        TContext
      > => {

      const mutationOptions = getAuthVerifyTwoFactorCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authGetCurrentUser = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserDTO>(
      {url: `/api/Auth/current-user`, method: 'GET', signal
    },
      );
    }
  

export const getAuthGetCurrentUserQueryKey = () => {
    return [`/api/Auth/current-user`] as const;
    }

    
export const getAuthGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof authGetCurrentUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetCurrentUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authGetCurrentUser>>> = ({ signal }) => authGetCurrentUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authGetCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthGetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof authGetCurrentUser>>>
export type AuthGetCurrentUserQueryError = ErrorType<unknown>


export function useAuthGetCurrentUser<TData = Awaited<ReturnType<typeof authGetCurrentUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authGetCurrentUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetCurrentUser<TData = Awaited<ReturnType<typeof authGetCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authGetCurrentUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetCurrentUser<TData = Awaited<ReturnType<typeof authGetCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthGetCurrentUser<TData = Awaited<ReturnType<typeof authGetCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const authGetProductEmailPreference = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProductEmailPreferenceDTO>(
      {url: `/api/Auth/product-email-preference`, method: 'GET', signal
    },
      );
    }
  

export const getAuthGetProductEmailPreferenceQueryKey = () => {
    return [`/api/Auth/product-email-preference`] as const;
    }

    
export const getAuthGetProductEmailPreferenceQueryOptions = <TData = Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthGetProductEmailPreferenceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authGetProductEmailPreference>>> = ({ signal }) => authGetProductEmailPreference(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthGetProductEmailPreferenceQueryResult = NonNullable<Awaited<ReturnType<typeof authGetProductEmailPreference>>>
export type AuthGetProductEmailPreferenceQueryError = ErrorType<unknown>


export function useAuthGetProductEmailPreference<TData = Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetProductEmailPreference>>,
          TError,
          Awaited<ReturnType<typeof authGetProductEmailPreference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetProductEmailPreference<TData = Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetProductEmailPreference>>,
          TError,
          Awaited<ReturnType<typeof authGetProductEmailPreference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetProductEmailPreference<TData = Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthGetProductEmailPreference<TData = Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetProductEmailPreference>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthGetProductEmailPreferenceQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const authUpdateProductEmailPreference = (
    updateProductEmailPreferenceDTO: UpdateProductEmailPreferenceDTO,
 ) => {
      
      
      return customInstance<ProductEmailPreferenceDTO>(
      {url: `/api/Auth/product-email-preference`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProductEmailPreferenceDTO
    },
      );
    }
  


export const getAuthUpdateProductEmailPreferenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateProductEmailPreference>>, TError,{data: UpdateProductEmailPreferenceDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authUpdateProductEmailPreference>>, TError,{data: UpdateProductEmailPreferenceDTO}, TContext> => {
    
const mutationKey = ['authUpdateProductEmailPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUpdateProductEmailPreference>>, {data: UpdateProductEmailPreferenceDTO}> = (props) => {
          const {data} = props ?? {};

          return  authUpdateProductEmailPreference(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUpdateProductEmailPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof authUpdateProductEmailPreference>>>
    export type AuthUpdateProductEmailPreferenceMutationBody = UpdateProductEmailPreferenceDTO
    export type AuthUpdateProductEmailPreferenceMutationError = ErrorType<unknown>

    export const useAuthUpdateProductEmailPreference = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateProductEmailPreference>>, TError,{data: UpdateProductEmailPreferenceDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUpdateProductEmailPreference>>,
        TError,
        {data: UpdateProductEmailPreferenceDTO},
        TContext
      > => {

      const mutationOptions = getAuthUpdateProductEmailPreferenceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authUpdateAccount = (
    updateAccountDTO: UpdateAccountDTO,
 ) => {
      
      
      return customInstance<UpdateAccountResponseDTO>(
      {url: `/api/Auth/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountDTO
    },
      );
    }
  


export const getAuthUpdateAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateAccount>>, TError,{data: UpdateAccountDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authUpdateAccount>>, TError,{data: UpdateAccountDTO}, TContext> => {
    
const mutationKey = ['authUpdateAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUpdateAccount>>, {data: UpdateAccountDTO}> = (props) => {
          const {data} = props ?? {};

          return  authUpdateAccount(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof authUpdateAccount>>>
    export type AuthUpdateAccountMutationBody = UpdateAccountDTO
    export type AuthUpdateAccountMutationError = ErrorType<unknown>

    export const useAuthUpdateAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateAccount>>, TError,{data: UpdateAccountDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUpdateAccount>>,
        TError,
        {data: UpdateAccountDTO},
        TContext
      > => {

      const mutationOptions = getAuthUpdateAccountMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authRequestMagicLink = (
    magicLinkRequestDTO: MagicLinkRequestDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MagicLinkResponseDto>(
      {url: `/api/Auth/request-magic-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: magicLinkRequestDTO, signal
    },
      );
    }
  


export const getAuthRequestMagicLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestMagicLink>>, TError,{data: MagicLinkRequestDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authRequestMagicLink>>, TError,{data: MagicLinkRequestDTO}, TContext> => {
    
const mutationKey = ['authRequestMagicLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRequestMagicLink>>, {data: MagicLinkRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  authRequestMagicLink(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthRequestMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof authRequestMagicLink>>>
    export type AuthRequestMagicLinkMutationBody = MagicLinkRequestDTO
    export type AuthRequestMagicLinkMutationError = ErrorType<unknown>

    export const useAuthRequestMagicLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestMagicLink>>, TError,{data: MagicLinkRequestDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRequestMagicLink>>,
        TError,
        {data: MagicLinkRequestDTO},
        TContext
      > => {

      const mutationOptions = getAuthRequestMagicLinkMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const authMagicLogin = (
    params?: AuthMagicLoginParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Auth/magic-login`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAuthMagicLoginQueryKey = (params?: AuthMagicLoginParams,) => {
    return [`/api/Auth/magic-login`, ...(params ? [params]: [])] as const;
    }

    
export const getAuthMagicLoginQueryOptions = <TData = Awaited<ReturnType<typeof authMagicLogin>>, TError = ErrorType<unknown>>(params?: AuthMagicLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMagicLogin>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMagicLoginQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMagicLogin>>> = ({ signal }) => authMagicLogin(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMagicLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthMagicLoginQueryResult = NonNullable<Awaited<ReturnType<typeof authMagicLogin>>>
export type AuthMagicLoginQueryError = ErrorType<unknown>


export function useAuthMagicLogin<TData = Awaited<ReturnType<typeof authMagicLogin>>, TError = ErrorType<unknown>>(
 params: undefined |  AuthMagicLoginParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMagicLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMagicLogin>>,
          TError,
          Awaited<ReturnType<typeof authMagicLogin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMagicLogin<TData = Awaited<ReturnType<typeof authMagicLogin>>, TError = ErrorType<unknown>>(
 params?: AuthMagicLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMagicLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMagicLogin>>,
          TError,
          Awaited<ReturnType<typeof authMagicLogin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMagicLogin<TData = Awaited<ReturnType<typeof authMagicLogin>>, TError = ErrorType<unknown>>(
 params?: AuthMagicLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMagicLogin>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthMagicLogin<TData = Awaited<ReturnType<typeof authMagicLogin>>, TError = ErrorType<unknown>>(
 params?: AuthMagicLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMagicLogin>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthMagicLoginQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get current impersonation status. 
Returns impersonation information if currently using an impersonation token.
 */
export const authGetImpersonationStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ImpersonationStatusDTO>(
      {url: `/api/Auth/status`, method: 'GET', signal
    },
      );
    }
  

export const getAuthGetImpersonationStatusQueryKey = () => {
    return [`/api/Auth/status`] as const;
    }

    
export const getAuthGetImpersonationStatusQueryOptions = <TData = Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthGetImpersonationStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authGetImpersonationStatus>>> = ({ signal }) => authGetImpersonationStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthGetImpersonationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof authGetImpersonationStatus>>>
export type AuthGetImpersonationStatusQueryError = ErrorType<unknown>


export function useAuthGetImpersonationStatus<TData = Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetImpersonationStatus>>,
          TError,
          Awaited<ReturnType<typeof authGetImpersonationStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetImpersonationStatus<TData = Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetImpersonationStatus>>,
          TError,
          Awaited<ReturnType<typeof authGetImpersonationStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetImpersonationStatus<TData = Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current impersonation status. 
Returns impersonation information if currently using an impersonation token.
 */

export function useAuthGetImpersonationStatus<TData = Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetImpersonationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthGetImpersonationStatusQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Return to original admin session from impersonation. 
This endpoint should be called while using an impersonation token.
 */
export const authReturnToOriginalSession = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ReturnToOriginalSessionDTO>(
      {url: `/api/Auth/return-to-original`, method: 'POST', signal
    },
      );
    }
  


export const getAuthReturnToOriginalSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authReturnToOriginalSession>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authReturnToOriginalSession>>, TError,void, TContext> => {
    
const mutationKey = ['authReturnToOriginalSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authReturnToOriginalSession>>, void> = () => {
          

          return  authReturnToOriginalSession()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthReturnToOriginalSessionMutationResult = NonNullable<Awaited<ReturnType<typeof authReturnToOriginalSession>>>
    
    export type AuthReturnToOriginalSessionMutationError = ErrorType<unknown>

    /**
 * @summary Return to original admin session from impersonation. 
This endpoint should be called while using an impersonation token.
 */
export const useAuthReturnToOriginalSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authReturnToOriginalSession>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authReturnToOriginalSession>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthReturnToOriginalSessionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    